import { render, staticRenderFns } from "./vehicle-sizechart.vue?vue&type=template&id=9bda5b5a"
import script from "./vehicle-sizechart.vue?vue&type=script&lang=js"
export * from "./vehicle-sizechart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports